<script lang="ts">
  import Accordion from '$components/accordion.svelte';
  import RichText from '$components/rich-text.svelte';

  import { isIconVariant } from '$components/ui/icon/icon.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';

  import type { ProductDetailStoryblok } from '$types/bloks';

  export let block: ProductDetailStoryblok;
  export let groupId: string | undefined = undefined;
  export let onInteract: (() => void) | undefined = undefined;
</script>

{#if block}
  {@const icon = block.icon?.toString()}
  <div use:storyblokEditable={block}>
    <Accordion
      title={block.title}
      as="h2"
      group={groupId}
      variant="product"
      icon={icon && isIconVariant(icon) ? icon : undefined}
      {onInteract}
    >
      <RichText
        doc={block.content}
        class={cn(
          '[&>p]:text-sm',
          '[&>*+p]:mt-1',
          '[&>p>img]:mt-3 [&>p>img]:w-full [&>p>img]:rounded-xs [&>p>img]:border [&>p>img]:border-primary/4 [&>p>img]:object-contain',
          '[&>*+.rich-text-button-cta]:mt-3',
          '[&>*+.rich-text-metrics]:mt-5',
          '[&>.rich-text-metrics+p]:mt-5'
        )}
      />
    </Accordion>
  </div>
{/if}
